const serverSide = typeof window === 'undefined'

export const navigateToPage = (path: string) => {
  if (serverSide) return
  window.location.href = path
}

export const redirectToPage = (page: string) => {
  if (serverSide) return
  window.location.replace(page)
}

export const redirectToPageInNewTab = (page: string) => {
  if (serverSide) return
  window.open(page, '_blank')
}

export const reloadPage = () => {
  if (serverSide) return
  window.location.reload()
}
